import { useEffect, useRef, useState } from 'react';
export default function useImageLoaded() {
    const ref = useRef(null);
    const [state, setState] = useState('loading');
    useEffect(() => {
        const img = ref.current;
        if (img) {
            const onLoad = () => setState('loaded');
            const onError = () => setState('error');
            if (img.complete) {
                onLoad();
            }
            else {
                img.addEventListener('load', onLoad);
                img.addEventListener('error', onError);
                return () => {
                    img.removeEventListener('load', onLoad);
                    img.removeEventListener('error', onError);
                };
            }
        }
    }, [ref]);
    return { ref, state };
}
